import ErrorHandlerUtils from 'utils/ErrorHandlerUtils';

const initState = {
    options : {
        reproductionTypes: [],
        nativityTypes: [],
        invasiveStatuses: [],
        securityTypes: [],
        taxonomySystems: [],
        taxonomyTypes: [],
        taxonomyCategories: [],
        names: [],
        substantiations: [],
        locDeterminization: [],
        substrates: [],
        qualities: [],
        locations: [],
        persons: [],
        events: [],
        sourceOwneds: [],
        repositories: [],
        noteTypes: [],
        evidenceFormats: [],
        subjects: [],
        towns: [],
        eventTypes: [],
        keywords: [],
        protectedStatuses: [],
        sRanks: [],
        rigcns: []
    },
    list: [],
    totalCount: 0,
    hasMore: false,
    isLoading: false,
    hasFailed: false,
    searchState: {}
};

export default function appStateReducer(state = initState, action = {}) {
    const { type, payload } = action;

    if (ErrorHandlerUtils.isError(action)) {
        return ErrorHandlerUtils.process(state, action);
    }

    switch (type) {
        case 'FETCH_ALL_OPTIONS_PENDING':
            return { ...state, isLoading: true, hasFailed: false };

        case 'FETCH_ALL_OPTIONS_REJECTED':
            return { ...state, isLoading: false, hasFailed: true };

        case 'FETCH_ALL_OPTIONS_FULFILLED':
            return {
                ...state,
                options: payload,
                isLoading: false,
                hasFailed: false
            };
        case 'FETCH_TABLE_LIST_PENDING':
            return { ...state, isLoading: true, hasFailed: false };
        case 'FETCH_TABLE_LIST_REJECTED':
            return { ...state, isLoading: false, hasFailed: true };
        case 'FETCH_TABLE_LIST_FULFILLED':
            return {
                ...state,
                list: payload.results || payload,
                totalCount: payload.totalCount || 0,
                hasMore: payload.hasMore || false,
                isLoading: false,
                hasFailed: false
            };
        case 'APPEND_TABLE_LIST_PENDING':
            return { ...state, isLoading: true, hasFailed: false };
        case 'APPEND_TABLE_LIST_REJECTED':
            return { ...state, isLoading: false, hasFailed: true };
        case 'APPEND_TABLE_LIST_FULFILLED':
            return {
                ...state,
                list: [...state.list, ...(payload.results || [])],
                totalCount: payload.totalCount || state.totalCount,
                hasMore: payload.hasMore || false,
                isLoading: false,
                hasFailed: false
            };
        case 'DELETE_RECORD_PENDING':
            return { ...state, isLoading: true, hasFailed: false };
        case 'DELETE_RECORD_REJECTED':
            return { ...state, isLoading: false, hasFailed: true };
        case 'DELETE_RECORD_FULFILLED':
            return {
                ...state,
                list: state.list.filter(item => item.id !== payload.objectId),
                totalCount: state.totalCount - 1,
                isLoading: false,
                hasFailed: false
            };
        case 'FETCH_SINGLE_LOOKUP_TABLE_PENDING': {
            const tableName = action.meta.tableName;
            const tableKey = tableName.charAt(0).toLowerCase() + tableName.slice(1) + 's';
            return {
                ...state,
                searchState: {
                    ...state.searchState,
                    [tableName]: {
                        ...state.searchState[tableName],
                        isLoading: true
                    }
                }
            };
        }
        case 'FETCH_SINGLE_LOOKUP_TABLE_REJECTED': {
            const tableName = action.meta.tableName;
            return {
                ...state,
                searchState: {
                    ...state.searchState,
                    [tableName]: {
                        ...state.searchState[tableName],
                        isLoading: false,
                        hasFailed: true
                    }
                }
            };
        }
        case 'FETCH_SINGLE_LOOKUP_TABLE_FULFILLED': {
            const { tableName, results } = payload;
            const tableKey = tableName.charAt(0).toLowerCase() + tableName.slice(1) + 's';
            return {
                ...state,
                options: {
                    ...state.options,
                    [tableKey]: results
                },
                searchState: {
                    ...state.searchState,
                    [tableName]: {
                        isLoading: false,
                        hasFailed: false
                    }
                }
            };
        }
        case 'SEARCH_LOOKUP_TABLE_PENDING': {
            const tableName = action.meta.tableName;
            return {
                ...state,
                searchState: {
                    ...state.searchState,
                    [tableName]: {
                        ...state.searchState[tableName],
                        isSearching: true
                    }
                }
            };
        }
        case 'SEARCH_LOOKUP_TABLE_REJECTED': {
            const tableName = action.meta.tableName;
            return {
                ...state,
                searchState: {
                    ...state.searchState,
                    [tableName]: {
                        ...state.searchState[tableName],
                        isSearching: false,
                        hasFailed: true
                    }
                }
            };
        }
        case 'SEARCH_LOOKUP_TABLE_FULFILLED': {
            const { tableName, results, totalCount, hasMore } = payload;
            return {
                ...state,
                searchState: {
                    ...state.searchState,
                    [tableName]: {
                        searchResults: results,
                        totalCount,
                        hasMore,
                        isSearching: false,
                        hasFailed: false
                    }
                }
            };
        }
        default: {
            return state;
        }
    }
}